import { formatPhoneNumber } from '../../../../../../utils';

interface IPropertyInformationDetailsProps {
  propertyInformation: {
    buyersAgentEmail: string;
    buyersAgentName: string;
    buyersWorkPhone: string;
    city: string;
    name: string;
    sellersAgentEmail: string;
    sellersAgentName: string;
    sellersName: string;
    sellersWorkPhone: string;
    state: string;
    streetAddress: string;
    zipCode: string;
    housePrice: string;
  };
}
export default function PropertyInformationDetails({ propertyInformation }: IPropertyInformationDetailsProps) {
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              Property Information
            </h2>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6 flex flex-col gap-6'>
          <div className='space-y-6'>
            <div className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Address</dt>
                <dd className='mt-1 text-sm text-gray-900'>
                  {propertyInformation?.streetAddress}, {propertyInformation?.city}, {propertyInformation?.state},{' '}
                  {propertyInformation?.zipCode}
                </dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>House Price</dt>
                <dd className='mt-1 text-sm text-gray-900'>$ {propertyInformation?.housePrice ?? 0}</dd>
              </div>
            </div>
            <div className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Buyers Agent Name</dt>
                <dd className='mt-1 text-sm text-gray-900'>{propertyInformation?.buyersAgentName}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Buyers Work Phone</dt>
                <dd className='mt-1 text-sm text-gray-900'>+1 {formatPhoneNumber(propertyInformation?.buyersWorkPhone)}</dd>
              </div>
            </div>
            <div className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Buyers Agent Email</dt>
                <dd className='mt-1 text-sm text-gray-900'>{propertyInformation?.buyersAgentEmail}</dd>
              </div>
            </div>

            <div className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Sellers Agent Name</dt>
                <dd className='mt-1 text-sm text-gray-900'>{propertyInformation?.sellersAgentName}</dd>
              </div>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Sellers Work Phone</dt>
                <dd className='mt-1 text-sm text-gray-900 capitalize'>+1 {formatPhoneNumber(propertyInformation?.sellersWorkPhone)}</dd>
              </div>
            </div>
            <div className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
              <div className='sm:col-span-1'>
                <dt className='text-sm font-medium text-gray-500'>Sellers Agent Email</dt>
                <dd className='mt-1 text-sm text-gray-900'>{propertyInformation?.sellersAgentEmail}</dd>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
